import { call, put, takeLatest, select } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { apiGetCall } from '../api';
import { getFAQs, getFAQsAutoComplete, getFAQsByEnhancementId, setFAQByEnhancementId, setFAQs, setFAQsAutoComplete } from '../slices/FAQSlice';

const URL = process.env.REACT_APP_API_BASE;

function* getFAQAutoCompleteSaga(action: PayloadAction<{ query: string, lang: string }>) {
    const query = new URLSearchParams(action.payload).toString();
    try {
        const response = yield call(apiGetCall, URL + 'faq-autocomplete?' + query, {headers: {isPublic: true}});
       yield(put(setFAQsAutoComplete(response.auto_completions)))
    } catch (error) {
       console.log(error)
        // yield call(showAPIerror, error, action.payload, 'getSellerAndUserIDs');
    }
}


function* getFAQSaga(action: PayloadAction<{ query: string, page: string, lang: string }>) {
    try {
        const query = new URLSearchParams(action.payload).toString();
        const existingPage = yield select(({faq}) => faq.faqs.page); // replace state.faqs.page with the actual path to your page in the state
        if (true || existingPage !== action.payload.page) {
        const response = yield call(apiGetCall, URL + 'faq?' + query, {headers: {isPublic: true}});
        yield(put(setFAQs(response)))
        if (response.search_results.length === 0 && response.enhancement_id) {
            yield put(getFAQsByEnhancementId({req_id: response.enhancement_id, lang: action.payload.lang}));
        }
        }
    } catch (error) {
        yield put(setFAQs({search_results: [], page: undefined, error: true}));
        console.log(error)
        // yield call(showAPIerror, error, action.payload, 'getSellerAndUserIDs');
    }
}

function* getFAQByEnhancementSaga(action: PayloadAction<{ req_id: string, lang: string }>) {
    const query = new URLSearchParams(action.payload).toString();
    try {
        const response = yield call(apiGetCall, URL + 'faq-enhancement?' + query, {headers: {isPublic: true}});
        yield(put(setFAQByEnhancementId(response)))
    } catch (error) {
        // yield call(showAPIerror, error, action.payload, 'getSellerAndUserIDs');
       yield put(setFAQs({search_results: [], page: undefined, error: true}));

        console.log(error)

    }
}



export default function* FAQSaga() {
    yield takeLatest(getFAQsAutoComplete.type, getFAQAutoCompleteSaga);
    yield takeLatest(getFAQs.type, getFAQSaga);
    yield takeLatest(getFAQsByEnhancementId.type, getFAQByEnhancementSaga);
}